import OwnerRoleChangeWarningView from "./OwnerRoleChangeWarningView";

const OwnerRoleChangeWarning = ({ show, handleClose, user, setShowOwnerChangeDialog }) => {
	return (
		<OwnerRoleChangeWarningView
			show={show}
			handleClose={handleClose}
			user={user}
		/>
	);
};

export default OwnerRoleChangeWarning;
